import instance from './instance';

export function createItem(data, sourcePage) {
  return instance.postForm(`/meeting_items${sourcePage ? `?source_page=${sourcePage}` : ''}`, data);
}

export function fetchActionItems(params) {
  return instance.get('/meeting_items/action_items', { params });
}

export function nestItem(data) {
  return instance.put('/meeting_items/nest', data);
}
